var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsNeeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.432,
    height: 46,
    viewBox: "0 0 40.432 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_018---More-Money",
    "data-name": "018---More-Money",
    transform: "translate(0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21.706,30.467a13.8,13.8,0,0,0-8.28-4.1,11.16,11.16,0,0,0-1.118-.056A8.744,8.744,0,0,0,6,28.783a8.992,8.992,0,0,0-2.415,7.426,13.811,13.811,0,0,0,4.1,8.281,13.811,13.811,0,0,0,8.281,4.1,8.99,8.99,0,0,0,7.425-2.415A8.992,8.992,0,0,0,25.8,38.747a13.8,13.8,0,0,0-4.1-8.28Zm.561,14.584a7.212,7.212,0,0,1-5.2,2.016,11.989,11.989,0,0,1-8.26-3.7c-4.176-4.176-4.93-10.214-1.683-13.462s9.286-2.493,13.462,1.682S25.514,41.8,22.267,45.051Z",
    transform: "translate(-0.734 -5.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M15.084,51.882a15.4,15.4,0,0,1-9.245-4.555,15.4,15.4,0,0,1-4.555-9.245,12.057,12.057,0,0,1,.148-3.474c-2.613,4-1.574,10.1,2.724,14.4s10.383,5.334,14.387,2.733a11.666,11.666,0,0,1-2.178.2q-.631,0-1.282-.064Z",
    transform: "translate(-0.012 -7.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M13.16,30.279a5.654,5.654,0,0,0-4.089,1.568C6.442,34.476,7.2,39.509,10.753,43.067s8.589,4.312,11.218,1.683,1.874-7.662-1.682-11.219a10.438,10.438,0,0,0-7.129-3.252Zm-.5,10.09a.793.793,0,0,1-.709-1.148l3.173-6.346a.794.794,0,1,1,1.42.709l-3.173,6.346a.793.793,0,0,1-.711.439Zm5.473-1.232-1.587,3.173a.794.794,0,1,1-1.42-.709l1.587-3.173a.794.794,0,1,1,1.42.709Z",
    transform: "translate(-1.561 -6.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M46.468,10.641a8.809,8.809,0,0,1-.252,2.3,15.072,15.072,0,0,1-4.088,6.879c-2.833,2.833-6.178,4.367-8.964,4.367-.065,0-.128-.006-.191-.007,2.257,1.762,6.895.42,10.415-3.1s4.868-8.19,3.08-10.437Z",
    transform: "translate(-6.827 -2.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M40.041,17.737a13.478,13.478,0,0,0,3.667-6.13c.472-1.953.184-3.577-.809-4.572a3.887,3.887,0,0,0-2.828-1.022c-2.367,0-5.4,1.4-7.877,3.878a13.485,13.485,0,0,0-3.668,6.13c-.476,1.955-.184,3.58.811,4.575C31.462,22.72,36.364,21.413,40.041,17.737Zm-2.954-1.175-3.365,1.122a.794.794,0,0,1-.5-1.507l3.365-1.122a.794.794,0,0,1,.5,1.507Zm-4.428-4.31,6.731-2.244a.794.794,0,0,1,.5,1.507l-6.731,2.243a.777.777,0,0,1-.251.041.793.793,0,0,1-.251-1.546Z",
    transform: "translate(-5.861 -1.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6461",
    "data-name": "Group 6461",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M4.271,14.813c2.788,2.787,6.481,3.8,8.066,2.221s.568-5.278-2.221-8.065a10.282,10.282,0,0,0-4.68-2.8A5.593,5.593,0,0,0,4.133,6a2.856,2.856,0,0,0-2.081.75,3.5,3.5,0,0,0-.582,3.386A10.283,10.283,0,0,0,4.271,14.813Z",
    transform: "translate(-0.279 -1.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M22.1,3.966a.793.793,0,0,0,.793-.793V.793a.793.793,0,0,0-1.587,0v2.38A.793.793,0,0,0,22.1,3.966Z",
    transform: "translate(-4.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M22.1,7a.793.793,0,0,0-.793.793v2.38a.793.793,0,1,0,1.587,0V7.793A.793.793,0,0,0,22.1,7Z",
    transform: "translate(-4.415 -1.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M24.1,6.587h2.38a.793.793,0,1,0,0-1.587H24.1a.793.793,0,1,0,0,1.587Z",
    transform: "translate(-4.828 -1.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M17.1,6.587h2.38a.793.793,0,0,0,0-1.587H17.1a.793.793,0,0,0,0,1.587Z",
    transform: "translate(-3.381 -1.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M43.816,36.235,42.23,37.821a.793.793,0,1,0,1.122,1.122l1.587-1.587a.793.793,0,0,0-1.122-1.122Z",
    transform: "translate(-8.69 -7.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M38.816,41.235,37.23,42.821a.793.793,0,1,0,1.122,1.122l1.587-1.587a.793.793,0,0,0-1.122-1.122Z",
    transform: "translate(-7.657 -8.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M43.357,41.235a.793.793,0,0,0-1.122,1.122l1.587,1.587a.793.793,0,0,0,1.122-1.122Z",
    transform: "translate(-8.696 -8.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M38.357,36.235a.793.793,0,0,0-1.122,1.122l1.587,1.587a.793.793,0,0,0,1.122-1.122Z",
    transform: "translate(-7.662 -7.445)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsNeeded);
export default __webpack_public_path__ + "static/media/points_needed.a5348a33e5cc0d401ce8113e861c9a09.svg";
export { ForwardRef as ReactComponent };